import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import {useDispatch, useSelector} from "react-redux";
import { store } from "react-notifications-component";
import styles from './edit-tag-modal.module.scss';
import TextField from "../FormElements/TextField";
import {BadgeTag} from "../Badge";
import ButtonFilled from "../FormElements/ButtonFilled";
import {useFormik} from "formik";
import branchApi from "../../store/branchStore/branchApi";
import branchActions from "../../store/branchStore/branchActions";
import Checkbox from "../FormElements/Checkbox";
import GroupConfigWarning from "../GroupConfigWarning";

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  content: {
    maxWidth: '500px',
    width: '100%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 32,
    borderRadius: 24,
  }
};

const EditTagModal = (props) => {
  const { t } = useTranslation();
  const { info } = useSelector(state => state.branchReducer);
  const dispatch = useDispatch()

  const {
    tagId,
    isOpen = !!tagId,
    setModal,
  } = props;

  const onModalClose = () => {
    setModal('');
  }

  const formik = useFormik({
    initialValues: {
      bonusPercentage: '',
      name: '',
      backgroundColor: '#F2F2F2',
      color: '#1E1E1E',
      isDiscount: false,
    },
    onSubmit: (async (values) => {
      try {
        if (info.id) {
          await branchApi.putBranchTagConfiguration(info.id, tagId, {
            bonus_percentage: Number(values.bonusPercentage),
            background_color: values.backgroundColor,
            title: values.name,
            color: values.color,
            is_discount: values.isDiscount,
          })
          dispatch(branchActions.getBranch(info.id));
          formik.resetForm()
          setModal('')
        }
      } catch (e) {
        const res = e.response ? e.response.data : null;

        store.addNotification({
          title: `Error code: ${res ? res.code : 'NULL'}`,
          message: `${res ? res.message : t('Notify.notRespond')}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      }
    })
  });

  useEffect(() => {
    if (info?.configuration?.tags?.length || !tagId) {
      const foundTag = info?.configuration?.tags?.find((tag) => tag.id === tagId);
      if (foundTag) {
        formik.setValues({
          bonusPercentage: foundTag.bonus_percentage,
          name: foundTag.name,
          backgroundColor: foundTag.background_color,
          color: foundTag.color,
          isDiscount: foundTag.is_discount || false,
        })
      } else {
        setModal('')
      }
    } else {
      setModal('')
    }
  }, [tagId]);

  return (
    <Modal
      ariaHideApp={false}
      // isOpen={isOpen}
      isOpen={isOpen}
      style={modalStyles}
      onRequestClose={onModalClose}
    >
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" onClick={onModalClose} style={{ zIndex: 2, position: 'absolute', right: '12px', top: '12px', cursor: 'pointer' }}>
        <rect x="28.7266" y="8.72949" width="3.52711" height="28.2169" rx="1.76356" transform="rotate(45 28.7266 8.72949)" fill="#AFAFAB"/>
        <rect x="8.77344" y="11.2236" width="3.52711" height="28.2169" rx="1.76356" transform="rotate(-45 8.77344 11.2236)" fill="#AFAFAB"/>
      </svg>
      <div className={styles.modal}>

        <div className={styles.container}>
          <GroupConfigWarning branch={info} variant="inline">
            {t('groupWarning.tagModal', { count: info?.group_branch_count ?? 0 })}
          </GroupConfigWarning>
          <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
            <div className={styles.block}>
              <div>
                <TextField
                  label={t('NSPromocode.comeUpWithAName')}
                  value={formik.values.name}
                  placeholder={t("corporative")}
                  error={false}
                  required
                  onChange={(e) => formik.setFieldValue('name', e.target.value)}
                />
              </div>
            </div>

            {formik.values.name && (
              <BadgeTag
                style={{
                  ...(formik.values.backgroundColor ? {backgroundColor: formik.values.backgroundColor} : {}),
                  ...(formik.values.color ? {color: formik.values.color} : {}),
                }}
              >
                {formik.values.name}
              </BadgeTag>
            )}

            <div className={styles.block}>
              <div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
                  <label>Выберите цвет текста</label>
                  <input type="color" value={formik.values.color} name="color" onChange={formik.handleChange} />
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <label>Выберите фоновый цвет</label>
                  <input type="color" value={formik.values.backgroundColor} name="backgroundColor" onChange={formik.handleChange} />
                </div>
              </div>
            </div>

            <div className={styles.block}>
              <div style={{ maxWidth: 300 }}>
                <TextField
                  label={t('NSTag.bonusPrecent')}
                  type="number"
                  required
                  placeholder={12}
                  value={formik.values.bonusPercentage}
                  onChange={(e) => formik.setFieldValue('bonusPercentage', e.target.value)}
                />
              </div>
            </div>

            <div className={styles.block}>
              <Checkbox
                label={t('NSTag.isDiscount') || 'Is Discount'}
                checked={formik.values.isDiscount}
                onChange={(e) => formik.setFieldValue('isDiscount', e.target.checked)}
              />
            </div>

            <div className={styles.footer}>
              <ButtonFilled style={{ width: '100%' }} type="submit" loading={formik.isSubmitting}>{t('edit')}</ButtonFilled>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export default EditTagModal;